import Node from 'ln/node/Node';
import SlrgUserSequenceModel from '../models/SlrgUserSequenceModel';
import CustomBase from './CustomBase';
import CustomSlrgUserSequenceModel from '../models/CustomSlrgUserSequenceModel';
import Course from './Course';
import UserFileList from './UserFileList';

class CustomSlrgUserSequence extends CustomBase {

	public userFileList:UserFileList;

	constructor( public model:CustomSlrgUserSequenceModel, courseView: Course ) {
		super( model, courseView );
	}
	
	public init(){
		super.init();

		// userfile list
		this.userFileList = new UserFileList( this.model as SlrgUserSequenceModel );
		this.userFileList.render();
		this.node.js( 'userfiles' ).append( this.userFileList.node );

		this.node.js( 'objective' ).blur.add( this.onObjectiveChange, this );
		this.node.js( 'method_location' ).blur.add( this.onMethodLocationChange, this );
		this.node.js( 'socialform' ).change.add( this.onSocialformChange, this );
		this.node.js( 'content' ).blur.add( this.onContentChange, this );
		this.node.js( 'expertise' ).blur.add( this.onExpertiseChange, this );
		this.node.js( 'notes' ).blur.add( this.onNoteChange, this );
		

		this.node.js('expand').click.add(() => {
			this.node.toggleClass( 'expanded' );
		});

	}

	private onObjectiveChange( n:Node ){
		this.model.objective = n.html;
		this.model.save();
	}

	private onExpertiseChange( n:Node ){
		this.model.expertise = n.html;
		this.model.save();
	}

	private onMethodLocationChange( n:Node ){
		this.model.method_location = n.html;
		this.model.save();
	}

	private onSocialformChange( n:Node ){
		this.model.socialform = n.value;
		this.model.save();
	}

	private onContentChange( n:Node ){
		this.model.content = n.html;
		this.model.save();
	}
	
	/**
	 * Callback when the note has changed
	 */
	private onNoteChange( n:Node ) {
		this.model.note = n.html;
		this.model.save();
	}
}

export default CustomSlrgUserSequence;